import React, { useState } from 'react';

const BulkImportModal = ({ onClose, addToast }) => {
  const [bggIds, setBggIds] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    const csrfToken = document.querySelector('meta[name="csrf-token"]').content;

    try {
      const response = await fetch('/api/v1/games/bulk_import', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-CSRF-Token': csrfToken,
        },
        body: JSON.stringify({ bgg_ids: bggIds.split('\n').filter(id => id.trim() !== '') }),
      });

      if (response.ok) {
        const data = await response.json();
        addToast(data.message || "Bulk import started successfully.");
        onClose();
      } else {
        const data = await response.json();
        addToast(data.error || 'An error occurred during the import.', 'error');
      }
    } catch (err) {
      addToast('An unexpected network error occurred.', 'error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <article className="modal-content" onClick={(e) => e.stopPropagation()}>
        <header className="modal-header">
          <h2>Bulk Import from BoardGameGeek</h2>
          <button aria-label="Close" className="close-button" onClick={onClose}>&times;</button>
        </header>
        <p>Enter one BoardGameGeek ID per line. The games will be imported in the background.</p>
        <form onSubmit={handleSubmit}>
          <label htmlFor="bgg_ids">BoardGameGeek IDs</label>
          <textarea id="bgg_ids" name="bgg_ids" rows="10" placeholder="e.g.&#10;174430&#10;161936&#10;167791" value={bggIds} onChange={(e) => setBggIds(e.target.value)} required />
          <button type="submit" disabled={isSubmitting} aria-busy={isSubmitting}>
            {isSubmitting ? 'Importing...' : 'Start Import'}
          </button>
        </form>
      </article>
    </div>
  );
};

export default BulkImportModal;